__turbopack_context__.v({
  "className": "zL6vfa_className",
  "variable": "zL6vfa_variable",
});
